import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
import { useAuth } from '@/hooks/useAuth';
import { guardarDestino } from '@/lib/destino';

export default function CapaSorteioPage() {
  const { rifaId } = useParams<{ rifaId: string }>();
  const navigate = useNavigate();
  const { user, pronto } = useAuth();
  const idNum = Number(rifaId);

  const [carregando, setCarregando] = useState(true);
  const [titulo, setTitulo] = useState('');
  const [imagem, setImagem] = useState<string | null>(null);

  const destino = `/meu-talao/${rifaId}`;

  useEffect(() => {
    if (!pronto) return;
    if (!user) {
      guardarDestino();
      navigate(`/entrar?voltar=${encodeURIComponent(`/minhas-rifas/${rifaId}/capa`)}`, {
        replace: true,
      });
      return;
    }
    let ativo = true;

    async function carregar() {
      setCarregando(true);
      try {
        const { data, error } = await supabase
          .from('vw_rifa_publica')
          .select('titulo, premio_imagem_url')
          .eq('rifa_id', idNum)
          .maybeSingle();
        if (error) throw error;

        const linha = data as { titulo: string | null; premio_imagem_url: string | null } | null;
        const url = linha?.premio_imagem_url?.trim() || null;

        if (!ativo) return;

        // Sem a arte, a capa não faz sentido: vai direto para a venda.
        if (!url) {
          navigate(destino, { replace: true });
          return;
        }

        const tit = linha?.titulo?.trim() || '';
        setTitulo(tit);
        setImagem(url);
        if (tit) document.title = tit;
      } catch (e) {
        // Nunca deixa a venda morrer numa tela de erro: cai direto no talão.
        if (ativo) {
          navigate(destino, { replace: true });
        }
      } finally {
        if (ativo) setCarregando(false);
      }
    }

    carregar();
    return () => {
      ativo = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rifaId, idNum, navigate, pronto, user]);

  if (carregando) {
    return (
      <div className="flex min-h-[calc(100vh-4rem)] items-center justify-center bg-background-100 px-4">
        <span className="flex h-10 w-10 items-center justify-center text-primary-500">
          <i className="ri-loader-4-line animate-spin text-3xl" />
        </span>
      </div>
    );
  }

  if (!imagem) return null;

  return (
    <div className="flex min-h-[calc(100vh-4rem)] flex-col bg-background-100">
      {/* A arte, em tela cheia, sem cortar. */}
      <main className="flex flex-1 items-center justify-center overflow-hidden px-3 pb-28 pt-4">
        <img
          src={imagem}
          alt={titulo || 'Ação entre amigos'}
          className="max-h-full w-auto max-w-full object-contain"
        />
      </main>

      {/* Botão fixo no rodapé, sempre visível. */}
      <div className="fixed inset-x-0 bottom-0 z-20 border-t border-secondary-200 bg-white px-4 py-4">
        <div className="mx-auto w-full max-w-[560px]">
          <button
            type="button"
            onClick={() => navigate(destino)}
            className="flex w-full cursor-pointer items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-6 py-4 text-base font-semibold tracking-wide text-white transition-colors hover:bg-primary-600"
          >
            VENDER
          </button>
        </div>
      </div>
    </div>
  );
}